import * as actionCreator from "./actionCreator";
import * as reducer from "./reducer";
export * from "./actions";
export * from "./models";

export const actions = {
    ...actionCreator
}

export const reducers = {
    gallery: reducer.reducer
}